module.exports = __webpack_public_path__ + "img/cl-claro.6c19effe.png";